Namespace 'Customer.Filters.Ticket'

class Customer.Filters.Ticket.ResponseFilterView extends Backbone.View
  template: JST['backbone/templates/customer/filters/tabs/ticket/response_filter']
  className: 'checkboxes filter-field-container response-filter mw-100 d-flex'

  events:
    'change #has-response-filter-check': '_toggleHasResponseCheck'

  initialize: ({filter}) ->
    @filter = filter

  render: ->
    hasResponseFilter = @filter.get('query').has_brand_response
    noResponseFilter = (hasResponseFilter == undefined || hasResponseFilter == null)
    @$el.html @template
      noResponseFilter: noResponseFilter
      hasResponse: hasResponseFilter
    @

  getHasResponse: =>
    filterActive = @$el.find("#has-response-filter-check")[0].checked
    @_updateHasResponse(filterActive)
    @filter.get('query').has_brand_response

  _toggleHasResponseCheck: =>
    filterActive = @$el.find("#has-response-filter-check")[0].checked
    @$el.find('.response-options').toggleClass 'unclickable'
    @$el.find('.btn.has-response').toggleClass 'disabled'
    @_updateHasResponse(filterActive)

  _updateHasResponse: (filterActive = true) =>
    if filterActive
      @filter.get('query').has_brand_response = @$el.find('.btn.has-response.active').hasClass('does-have')
    else
      @filter.get('query').has_brand_response = undefined
